<app-modal-dialog [show]="showModal" (closed)="closeModalEmit()"  size="lg" position="top" #modal>
    <div class="modal-header" modal-header>
        <h3>Detalle de Gastos</h3>
        <h4 class="i-hover ml-4">
            <i class="fa fa-xmark" (click)="closeModal(modal)"></i>
        </h4>
    </div>

    <div class="modal-body" modal-body>
        <div class="d-flex flex-column" *ngIf="expenseDoc!=null">
            <div class="d-flex flex-row flex-wrap gap-4">
                <h6 class="font-bold">Serie: <span class="font-medium">{{expenseDoc.series}}</span></h6>
                <h6 class="font-bold">Numero: <span class="font-medium">{{expenseDoc.number}}</span></h6>
            </div>
            <div class="d-flex flex-row flex-wrap gap-4">
                <h6 class="font-bold">Proveedor: <span class="font-medium">{{expenseDoc.vendorName}}</span></h6>
                <h6 class="font-bold">NIT: <span class="font-medium">{{expenseDoc.nit}}</span></h6>
            </div>
            <div class="d-flex flex-col flex-wrap gap-4">
                <!-- <h6 class="font-bold">Bodega: <span class="font-medium">{{expenseDoc.warehouseData.name}}</span></h6> -->
                <h6 class="font-bold">Fecha: <span class="font-medium">{{convertToString(expenseDoc.date)}}</span></h6>
            </div>
        </div>
        <div class="row">
            <div class="table-responsive" style="margin-bottom: 0;">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="ta">
                                #
                            </th>
                            <th class="">
                                Nombre
                            </th>
                            <th class="ta">
                                Cantiad
                            </th>
                            <th class="ta">
                                Precio
                            </th>
                            <th class="ta">
                                Subtotal
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let item of details; let i = index">
                            <tr>
                                <td>{{i+1}}</td>
                                <td class="limit-td-300">{{item.description}}</td>
                                <td>{{item.quantity.toFixed(2)}}</td>
                                <td>{{item.price | currency: (expenseDoc.currency==0? 'Q':'$')}}</td>
                                <td class="text-right">{{subtotal(item.quantity,item.price) | currency: (expenseDoc.currency==0? 'Q':'$')}}</td>
                            </tr>
                        </ng-container>
                        <tr>
                            <td colspan="4"> Total</td>
                            <td class="font-bold text-right">{{total | currency: (expenseDoc.currency==0? 'Q':'$')}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
					
        </div>
    </div>
</app-modal-dialog>